export enum NotificationsStoreStatus {
  Loading = 'loading',
  Updating = 'updating',
  NotificationsCountLoading = 'notifications_count_loading',
  Creating = 'creating',
  MarkAllAsRead = 'mark_all_as_read',
}
